import { AccountApi } from './common/api/account-api';
import { BonusSettlementsApi } from './features/bonus-settlements/api/bonus-settlements-api';
import { BuyAgainApi } from './features/buy-again/buy-again-api';
import { CommonApi } from './common/api/api';
import { ContactsLoginsApi } from './features/contacts-logins/contacts-logins-api';
import { DemandApi } from './features/demands/api/demand-api';
import { InquiryApi } from './features/inquiry/inquiry-api';
import { NotificationsApi } from './common/api/notifications-api';
import { OrderApprovalsApi } from './features/order-approvals/order-approvals-api';
import { OrdersApi } from './features/orders/orders-api';
import { SupplierApi } from './common/api/supplier-api';

export class Api {
    constructor(private baseUrl: string) {
        this.common = new CommonApi(this.baseUrl);
        this.account = new AccountApi(this.baseUrl);
        this.supplier = new SupplierApi(this.baseUrl);
        this.demand = new DemandApi(this.baseUrl);
        this.bonusSettlements = new BonusSettlementsApi(this.baseUrl);
        this.contactsLogins = new ContactsLoginsApi(this.baseUrl);
        this.notifications = new NotificationsApi(this.baseUrl);
        this.inquiry = new InquiryApi(this.baseUrl);
        this.orders = new OrdersApi(this.baseUrl);
        this.orderApprovals = new OrderApprovalsApi(this.baseUrl);
        this.buyAgain = new BuyAgainApi(this.baseUrl);
    }

    public common: CommonApi;
    public account: AccountApi;
    public supplier: SupplierApi;
    public demand: DemandApi;
    public bonusSettlements: BonusSettlementsApi;
    public contactsLogins: ContactsLoginsApi;
    public notifications: NotificationsApi;
    public inquiry: InquiryApi;
    public orders: OrdersApi;
    public orderApprovals: OrderApprovalsApi;
    public buyAgain: BuyAgainApi;
}
